import React, { useState } from "react";
import './LoginForm.css';
import RecuperarSenhaForm from '../RecuperarLoginForm/RecuperarSenhaForm';
import { FaUser, FaEye, FaEyeSlash } from "react-icons/fa";
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';

function getCookieValue(nome) {
    const match = document.cookie.split('; ').find(r => r.startsWith(nome + '='));
    return match ? match.split('=')[1] : null;
}

function setCookie(nome, valor, dias) {
    var expires = "";
    if (dias) {
        var data = new Date();
        data.setTime(data.getTime() + (24*60*60*1000 * dias));
        expires = "; expires=" + data.toGMTString();
    }
    document.cookie = nome + "=" + (valor || "") + expires + "; path=/";
}

function LoginForm () {
    const [form, setForm] = useState({
        email: "",
        senha: ""
    });

    const [div_esqueceu_senha, set_div_esqueceu_senha] = useState(false);
    const [showChave, setShowChave] = useState(false);
    const [selecionarEmpresa, setSelecionarEmpresa] = useState(null); // { empresas: [], token: '' }
    const navigate = useNavigate();

    const btn_visibilidade_chave = () => {
        setShowChave((prev) => !prev);
    };

    const logar = (evento) => {
        evento.preventDefault(); 

        Swal.fire({
            html: 'Verificando o seu login...',
            imageUrl: 'ufo.gif',
            imageWidth: 100,
            imageHeight: 100,
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        fetch(`${process.env.REACT_APP_API_URL}/api/autenticacoes/login`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                email: form.email,
                senha: form.senha,
                device_token: getCookieValue("lk_device") || ""
            })
        })
        .then((response) => response.json())
        .then((result) => {
            if (result.status === "erro") {
                Swal.fire({ text: result.mensagem, icon: "error" });
            } else if (result.status === "dispositivo_confiado") {
                Swal.close();
                setCookie("info", result.token, 1);
                navigate("/principal");
            } else if (result.status === "selecionar_empresa") {
                Swal.close();
                setSelecionarEmpresa({ empresas: result.empresas, token: result.token });
            } else if (result.status === "senha_insegura") {
                Swal.fire({
                    title: "Atualização de senha necessária!",
                    text: result.mensagem,
                    icon: "warning",
                }).then(() => {
                    setCookie("info", result.token, 1);
                    navigate("/alterar_senha_obrigatoria?obrigatorio=true&token=" + result.token);
                });
            } else if (result.status !== "ok") {
                Swal.fire({
                    title: "Primeiro contato detectado!",
                    text: "Continue para desbloquear seu acesso. 🛸",
                    icon: "info",
                }).then(() => {
                    setCookie("info", result.token, 1);
                    navigate("/cadastrar_token");
                });
            } else {
                if (result.permite_confiar_dispositivo) {
                    sessionStorage.setItem("permite_confiar_dispositivo", "true");
                } else {
                    sessionStorage.removeItem("permite_confiar_dispositivo");
                }
                Swal.fire({
                    title: "Login bem-sucedido!",
                    text: "Prepare-se para validar seu acesso. 🚀🌠",
                    icon: "success",
                }).then(() => {
                    setCookie("info", result.token, 1);
                    navigate("/validar");
                });
            }
        })
        .catch((error) => {
            console.log(error);
            Swal.fire({
                title: "Ops!",
                text: "Parece que um UFO causou uma interferência. Por favor, tente novamente mais tarde.",
                icon: "warning"
            });
        });
    };

    const detectar_tecla_enter = (evento) => {
        if (evento.key === 'Enter') {
            logar(evento);
        }
    };

    const handleSelecionarEmpresa = (empresaId) => {
        Swal.fire({
            html: 'Entrando na empresa...',
            imageUrl: 'ufo.gif',
            imageWidth: 100,
            imageHeight: 100,
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => { Swal.showLoading(); }
        });

        fetch(`${process.env.REACT_APP_API_URL}/api/autenticacoes/selecionar_empresa`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authority': selecionarEmpresa.token,
            },
            body: JSON.stringify({ empresa_id: empresaId, device_token: getCookieValue("lk_device") || "" })
        })
        .then(r => r.json())
        .then(result => {
            if (result.status === "erro") {
                Swal.fire({ text: result.mensagem, icon: "error" });
                return;
            }
            if (result.status === "dispositivo_confiado") {
                Swal.close();
                setCookie("info", result.token, 1);
                navigate("/principal");
                return;
            }
            if (result.status === "primeiro_acesso") {
                Swal.fire({ title: "Primeiro contato detectado!", text: "Continue para desbloquear seu acesso. 🛸", icon: "info" })
                    .then(() => { setCookie("info", result.token, 1); navigate("/cadastrar_token"); });
                return;
            }
            if (result.permite_confiar_dispositivo) {
                sessionStorage.setItem("permite_confiar_dispositivo", "true");
            } else {
                sessionStorage.removeItem("permite_confiar_dispositivo");
            }
            Swal.fire({ title: "Login bem-sucedido!", text: "Prepare-se para validar seu acesso. 🚀🌠", icon: "success" })
                .then(() => { setCookie("info", result.token, 1); navigate("/validar"); });
        })
        .catch(() => {
            Swal.fire({ title: "Ops!", text: "Erro ao selecionar a empresa. Tente novamente.", icon: "warning" });
        });
    };

    if (selecionarEmpresa) {
        return (
            <div className='login-box'>
                <img src="lockus-icon.svg" className="logo" alt="Logo"/>
                <h1>Lockus</h1>
                <p style={{ color: '#aaa', marginBottom: '16px' }}>Selecione sua empresa</p>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', width: '100%' }}>
                    {selecionarEmpresa.empresas.map(emp => (
                        <button
                            key={emp.id}
                            onClick={() => handleSelecionarEmpresa(emp.id)}
                            style={{
                                background: '#1a0f2e',
                                border: '1px solid #6c3fc5',
                                color: '#fff',
                                borderRadius: '8px',
                                padding: '12px 16px',
                                cursor: 'pointer',
                                fontSize: '15px',
                                textAlign: 'left',
                                transition: 'background 0.2s'
                            }}
                            onMouseEnter={e => e.currentTarget.style.background = '#2d1a50'}
                            onMouseLeave={e => e.currentTarget.style.background = '#1a0f2e'}
                        >
                            {emp.nome}
                        </button>
                    ))}
                </div>
                <a
                    onClick={() => setSelecionarEmpresa(null)}
                    style={{ marginTop: '16px', color: '#aaa', cursor: 'pointer', fontSize: '13px' }}
                >
                    Voltar ao login
                </a>
            </div>
        );
    }

    return div_esqueceu_senha ? (
        <RecuperarSenhaForm onCancel={() => set_div_esqueceu_senha(false)} />
    ) : (
        <div className='login-box'>
            <img src="lockus-icon.svg" className="logo" alt="Logo"/>
            <h1>Lockus</h1>
            <div className="input-box">
                <input
                    id="iptEmail"
                    value={form.email}
                        onChange={(e) => {
                            if (e.target.value.length <= 40) {
                                setForm({ ...form, email: e.target.value });
                            } else {
                                Swal.fire({
                                    title: "Limite excedido!",
                                    text: "Máximo de 40 caracteres permitidos para o email.",
                                    icon: "warning",
                                    timer: 2000,
                                    showConfirmButton: false
                                });
                            }
                        }}
                    onKeyDown={detectar_tecla_enter}
                    type="text"
                    placeholder='Email'
                    required
                    maxLength={40}
                />
                <FaUser className="icon" />
            </div>
            <div className="input-box">
                <input
                    id="iptSenha"
                    value={form.senha}
                    onChange={(e) => {
                        if (e.target.value.length <= 50) {
                            setForm({ ...form, senha: e.target.value });
                        } else {
                            Swal.fire({
                                title: "Limite excedido!",
                                text: "Máximo de 50 caracteres permitidos para a senha.",
                                icon: "warning",
                                timer: 2000,
                                showConfirmButton: false
                            });
                        }
                    }}
                    onKeyDown={detectar_tecla_enter}
                    type={showChave ? "text" : "password"}
                    placeholder='Senha'
                    required
                />
                <button type="button" className="eye-icon" onClick={btn_visibilidade_chave}>
                    {showChave ? <FaEye  /> : <FaEyeSlash />}
                </button>
            </div>
            <div className="remember-forgot">
                <a onClick={() => set_div_esqueceu_senha(true)}>Esqueceu sua senha?</a>
            </div>
            <button type="submit" onClick={logar}>Entrar</button>
        </div>
    );
}

export default LoginForm;
